<template>
  <div class="student-layout" v-if="listCustom && listCustom.fields">
    <div class="item-layout">
      <div
        class="item-common-layout"
        v-for="item in listCustom.fields"
        :key="item.fieldId"
      >
        <label class="label-ui">{{ item.labelName }}</label>
        <input
          type="text"
          :placeholder="item.placeholder"
          v-model="studentInfo[item.labelKey]"
        />
      </div>
    </div>
    <!-- <div class="item-layout">
            <div class="item-common-layout">
                <label class="label-ui">学员手机号</span></label>
                <input type="text" placeholder="请输入学员手机号" v-model="studentInfo.phone">
            </div>
        </div> -->
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props: {
    studentInfo: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState(['confirmProduct']),
    listCustom() {
      return (
        this.confirmProduct &&
        this.confirmProduct.collectInfo &&
        this.confirmProduct.collectInfo.custom &&
        this.confirmProduct.collectInfo.custom[0]
      )
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/css/mixin';
.student-layout {
  margin-bottom: 0.2rem;
  border-radius: 0.16rem;
  overflow: hidden;
  padding: 0.2rem 0;
  background-color: #fff;
  .item-layout {
    .item-common-layout {
      @include border(bottom, #f2f2f2, 1px);
      color: #000000;
      font-size: rem(26px);
      input {
        text-align: right;
      }
      &:last-child {
        @include border(bottom, #fff, 0);
      }
    }
  }
}
</style>
